import { IOrder, Order } from "@/entities/order/order";
import { API, graphqlOperation } from "aws-amplify";
import { IDraftOrderRepository } from "./draftOrder.types";
import * as queries from "@/graphql/queries";
import * as mutations from "@/graphql/mutations";
import {
    CreateDraftOrderInput,
    CreateDraftOrderMutation,
    CreateSaleMutation,
    GetDraftOrderQuery,
    GetSaleQuery,
    UpdateDraftOrderInput,
    UpdateDraftOrderMutation,
    UpdateSaleMutation,
} from "@/API";

// export const ENDPOINT_PATH = getEndpoint("/api/order");

export class DraftOrderAPIRepository implements IDraftOrderRepository {
    async get(id: string): Promise<IOrder | undefined> {
        console.log("get input:", id);
        const result = (await API.graphql({
            ...graphqlOperation(queries.getDraftOrder, {
                id,
            }),
            ...{
                authMode: "AMAZON_COGNITO_USER_POOLS",
            },
        })) as any;

        console.log({ result });

        const o = (result?.data as GetDraftOrderQuery).getDraftOrder;
        console.log({ o });
        // const draftOrder: any = o;

        if (o) {
            const otherField = JSON.parse(o.data!);

            const draftOrder: any = {
                ...otherField,
            };
            return new Order(draftOrder);
        }
        return;
    }
    async create(data: IOrder): Promise<IOrder> {
        console.log("create input:", data);

        const input: CreateDraftOrderInput = {
            id: data.ownerId,
            data: JSON.stringify(data),
        };

        const result = (await API.graphql({
            ...graphqlOperation(mutations.createDraftOrder, {
                input,
            }),
            ...{
                authMode: "AMAZON_COGNITO_USER_POOLS",
            },
        })) as any;
        const o = (result?.data as CreateDraftOrderMutation).createDraftOrder;
        const draftOrder = JSON.parse(o!.data!);
        return new Order(draftOrder);
    }
    async update(data: IOrder): Promise<IOrder> {
        console.log("update input:", data);

        const input: UpdateDraftOrderInput = {
            id: data.ownerId!,
            data: JSON.stringify(data),
        };

        const result = (await API.graphql({
            ...graphqlOperation(mutations.updateDraftOrder, {
                input,
            }),
            ...{
                authMode: "AMAZON_COGNITO_USER_POOLS",
            },
        })) as any;
        const o = (result?.data as UpdateDraftOrderMutation).updateDraftOrder;
        const draftOrder = JSON.parse(o!.data!);
        return new Order(draftOrder);
    }
    async delete(id: string): Promise<void> {
        return;
    }
}
